import { createFileRoute, useParams } from "@tanstack/react-router";
import { requirePermission } from "@/lib/feature-gate";
import { z } from "zod";
import { ContactDetailPage } from "@/components/crm/ContactDetailPage";

export const Route = createFileRoute("/admin/_layout/crm/contacts_/$id")({
  beforeLoad: async () => {
    await requirePermission("crm.contact.view");
  },
  validateSearch: z.object({ tab: z.string().min(1).catch("general").default("general") }),
  component: AdminContactDetail,
});

function AdminContactDetail() {
  const { id } = useParams({ from: "/admin/_layout/crm/contacts_/$id" });
  const { tab } = Route.useSearch();
  return <ContactDetailPage contactId={id} role="admin" activeTab={tab} />;
}
